import { useNavigate, useParams } from 'react-router-dom';
import { StandardButton } from '@components/common';
import type { SxProps, Theme } from '@mui/material';

type Props = {
  label?: string;
  sx?: SxProps<Theme>;
};

export const CustomerReviewButton = ({
  label = 'Customer Review',
  sx
}: Props) => {
  const navigate = useNavigate();
  const { jobNumber } = useParams<{ jobNumber: string }>();

  const handleClick = () => {
    if (jobNumber) {
      navigate(`/work/${jobNumber}/review`);
    }
  };

  return (
    <StandardButton variant="secondary" onClick={handleClick} sx={sx}>
      {label}
    </StandardButton>
  );
};
